module.exports = __webpack_public_path__ + "static/media/UK-Edinburgh.906f79f6.png";